/**
 * Smoke-test endpoint hit by post-deploy CI. Returns a minimal OK page.
 * The response body is stable so curl checks can grep for "jubuddy-ok".
 */
export function HealthPage() {
  return (
    <div className="p-4 font-mono text-xs">
      <p>jubuddy-ok</p>
      <p>build: {String(import.meta.env.MODE)}</p>
    </div>
  );
}
